export const FETCH_TAB_CELL_SUCCESS = 'FETCH_TAB_CELL_SUCCESS';
export const DUMMY_ACTION_M = 'DUMMY_ACTION_M';
